import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { SelectModule } from '@sag-ui';
import { RegionSelectComponent } from '../../../../shared/components/region-select/region-select.component';
import { Region } from '@cod-monorepo/interfaces';
import { FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RegionFormGroup } from '../../../models/cod-create.model';

@Component({
    selector: 'app-cod-region-step',
    templateUrl: './region.component.html',
    imports: [CommonModule, SelectModule, RegionSelectComponent, FormsModule, ReactiveFormsModule],
    standalone: true
})
export class CodRegionStepComponent {
    @Input() regionForm: FormGroup<RegionFormGroup> | undefined;

    protected regions = Region;
}
